'use strict';

import * as Props from '../Props';

const angular = require('angular');

const ImageProperties = {
    Basic: {
        'ControlType': 'Image',
        'Label': {
            name: 'label',
            selectedValue: 'Image',
            type: 'textbox',
            hidden: true,
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Image'),
        'Source': {
            name: 'source',
            type: 'radio',
            selectedValue: '0',
            list: [
                {
                    name: 'URL',
                    value: '0'
                },
                {
                    name: 'upload',
                    value: '1'
                }
            ]
        },
        'Url': {
            name: 'Url',
            selectedValue: '',
            type: 'textbox',
            hidden: true
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'alignment': {
                    type: 'radio-btn',
                    selectedValue: 'left',
                    options: [{
                        value: 'left',
                        title: 'align.left',
                        icon: 'fa fa-align-left'
                    }, {
                        value: 'center',
                        title: 'align.center',
                        icon: 'fa fa-align-justify'
                    }, {
                        value: 'right',
                        title: 'align.right',
                        icon: 'fa fa-align-right'
                    }]
                },
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush'
                }
            }
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Size: {
        'Height': {
            name: 'height',
            selectedValue: 'auto',
            type: 'textbox'
        },
        'Width': {
            name: 'width',
            selectedValue: 'auto',
            type: 'textbox'
        },
        'Name': {
            selectedValue: 'Size',
            hidden: true
        }
    }
};

export default ImageProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Image.ts